import {spawnErrorToast} from '@hm/fundamental'
import {AxiosError} from 'axios'
import {useTranslation} from 'react-i18next'

import {useRefraQuery} from '@refra/modules/common/hooks'
import type {AttachedDocument, ErrorResponse} from '@refra/modules/common/types'
import {logger} from '@refra/modules/common/utils'

interface useAttachedDocumentsFilesProps {
  documents: AttachedDocument[]
  // Defines whether we should use preview url if it exists (e.g. for images)
  shouldUsePreview?: boolean
}

export const useAttachedDocumentsFilesQuery = ({
  documents,
  shouldUsePreview = false
}: useAttachedDocumentsFilesProps) => {
  const {t} = useTranslation()

  return useRefraQuery({
    queryKey: 'attachedDocumentsFiles',
    params: [{documents, shouldUsePreview}],
    throwOnError: (error) => {
      const axiosError = error as AxiosError<ErrorResponse>
      const errorDetails =
        axiosError?.response?.data.detail ?? axiosError.message ?? axiosError.response?.status
      logger
        .context('useAttachedDocumentsFilesQuery')
        .extras({errorDetails})
        .error('Error occurred while fetching files for attached documents')

      spawnErrorToast(t('error.attachedDocumentsFiles'))

      return false
    }
  })
}
